export default __webpack_public_path__ + "static/media/043-botany.8c902357.svg";